import { render } from "./brain.vue?vue&type=template&id=0f372d3b&scoped=true"
import script from "./brain.vue?vue&type=script&lang=js"
export * from "./brain.vue?vue&type=script&lang=js"

import "./brain.vue?vue&type=style&index=0&id=0f372d3b&scoped=true&lang=css"

import exportComponent from "D:\\DAIHAO\\AAAAA\\smart_brain_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f372d3b"]])

export default __exports__